import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import { parseValue } from '../utils/Common';


const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const Wallet = () => {
    let navigate = useNavigate();
    const [addPaymentDate, setAddPaymentDate] = useState(0);
    const [showWalletHistory, setShowWalletHistory] = useState(0);
    const [walletData, setWalletData] = useState([]);
    const [walletDataToApprove, setWalletDataToApprove] = useState([]);
    const [walletId, setWalletId] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});

    const getWalletDataToApprove = async () => {
        let data = {
            'start_date': $('#Date-from').val(),
            'end_date': $('#Date-to').val(),
            'source': 'admin'
        }
        let response = await common.apiRequest('post', '/users/get-wallet-data', data);
        if (response.status == 200) {
            if (response.data.code == 'success') {
                setWalletDataToApprove(response.data.data);
            } else {
                alert(response.data.error);
            }
        } else {
            alert(response.data.error);
        }
    }

    const approveWithdrawlPayment = async (id, status) => {
        let data = {
            'id': id,
            'status': status
        }
        let response = await common.apiRequest('post', '/admin/update-wallet-or-add-payment-date', data);
        if (response.status == 200) {
            if (response.data.code == 'success') {
                alert(response?.data?.message)
                getWalletDataToApprove();
            } else {
                alert(response.data.error);
            }
        } else {
            alert(response.data.error);
        }
    }

    const getWalletTransactionForUser = async (userId) => {
        setWalletData([]);
        let data = {
            "user_id": userId,
            'start_date': $('#Date-from').val(),
            'end_date': $('#Date-to').val(),
        }
        let response = await common.apiRequest('post', '/users/get-wallet-data', data);
        if (response.status == 200) {
            if (response.data.code == 'success') {
                setWalletData(response.data.data);
                setShowWalletHistory(!showWalletHistory);
            } else {
                alert(response.data.error);
            }
        } else {
            alert(response.data.error);
        }
    }

    const updatePaymentDate = async () => {
        let finalData = {
            "id": walletId,
            "payment_date": moment($('#payment-date').val()).format("YYYY-MM-DD HH:mm:ss"),
        }
        let response = await common.apiRequest('post', '/admin/update-wallet-or-add-payment-date', finalData);
        if (response.status == 200) {
          if (response.data.code == 'success') {
            alert(response.data.message);
            setAddPaymentDate(!addPaymentDate);
            getWalletDataToApprove();
          } else {
            alert(response.data.error);
          }
        } else {
          alert(response.data.error);
        }
        setWalletId(0);
    }

    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
            alert("Access Denied");
            navigate("/");
            return;
        } else {
            setUserRights(rights);
            if (!localStorage.getItem('admin_token')) {
                navigate('/login');
            }
            getWalletDataToApprove();
        }
    }

    const dataToExport = walletDataToApprove.map((data, index) => {
        return {
            "S. No.": index + 1,
            "Transaction Date": moment(data.created_at).format('YYYY-MM-DD HH:mm:ss'),
            "User Registration ID": data?.user?.reg_id || 'N/A',
            "First Name": data?.user?.first_name || 'N/A',
            "Middle Name": data?.user?.middle_name || 'N/A',
            "Last Name": data?.user?.last_name || 'N/A',
            "Bank Name": data?.user?.bank_name || 'N/A',
            "Bank Account No": data?.user?.bank_account_no || 'N/A',
            "IFSC Code": data?.user?.ifsc_code || 'N/A',
            "Type": data?.type || 'N/A',
            "Wallet Balance": parseValue(data?.user?.wallet, 'float') || 'N/A',
            "Debit": parseValue(data.debit, 'float') || 'N/A',
            "Bank Charges": parseValue(data.bank_charges, 'float') || 'N/A',
            "Settlement Amount": parseValue(data.settlement_amount, 'float') || 'N/A',
            "Balance": parseValue(data.balance, 'float') || 'N/A',
            "Withdrawal Status": data?.withdrawl_status == 1 
                ? 'Request Sent' 
                : data?.withdrawl_status == 2 
                ? 'Approved' 
                : 'NA',
            "Withdrawal Approved Date": ["1", "2"].includes(data?.withdrawl_status) 
                ? data?.withdrawl_approved_date || 'NA' 
                : 'NA',
            "Payment Date": ["2"].includes(data?.withdrawl_status)
                ? data?.payment_date || 'NA' 
                : 'Approve First',
        };
    });

    const subDataToExport = walletData.map((data, index) => {
        return {
            "S. No.": index + 1,
            "Transaction Date": moment(data.created_at).format('YYYY-MM-DD HH:mm:ss'),
            "Type": data?.type || 'N/A',
            "Order ID": data?.order_item?.order?.order_id || 'N/A',
            "Credit": common.parseValue(data.credit, 'float') || 'N/A',
            "Debit": common.parseValue(data.debit, 'float') || 'N/A',
            "Bank Charges": parseValue(data.bank_charges, 'float') || 'N/A',
            "Settlement Amount": parseValue(data.settlement_amount, 'float') || 'N/A',
            "Balance": common.parseValue(data.balance, 'float') || 'N/A',
            "Withdrawal Status": data?.withdrawl_status == 1 
                ? 'Request Sent' 
                : data?.withdrawl_status == 2 
                ? 'Approved' 
                : 'NA',
            "Withdrawal Approved Date": ["1", "2"].includes(data?.withdrawl_status) 
                ? data?.withdrawl_approved_date || 'Yet to be updated' 
                : 'NA',
            "Payment Date": ["1", "2"].includes(data?.withdrawl_status)
                ? data?.payment_date || 'Yet to be updated' 
                : 'NA',
        };
    });
    

    const handleExportCSV = (sub = 0) => {
        exportToCSV(sub ? subDataToExport : dataToExport, 'Wallet');
    }
    
    const handleExportExcel = (sub = 0) => {
        exportToExcel(sub ? subDataToExport : dataToExport, 'Wallet');
    }
    
    const handleExportPDF = (sub = 0) => {
        exportToPDF(sub ? subDataToExport : dataToExport, 'Wallet');
    }

    return (
        <>
            <h1>Wallet</h1><br />
            <div className='row'>
                <div className='col-md-2'>
                    <input type='date' id='Date-from' className='form-control' defaultValue={moment().startOf('month').format('YYYY-MM-DD')}/>
                </div>
                <div className='col-md-2'>
                    <input type='date' id='Date-to' className='form-control' defaultValue={moment().endOf('month').format('YYYY-MM-DD')}/>
                </div>
            </div>
            <div className='row mt-3'>
                <div className='col-md-12'>
                    <button type="button" className='btn btn-info mr-3' onClick={() => handleExportCSV(0)}>Export to CSV</button>
                    <button type="button" className='btn btn-info mr-3' onClick={() => handleExportExcel(0)}>Export to Excel</button>
                    <button type="button" className='btn btn-info mr-3' onClick={() => handleExportPDF(0)}>Export to PDF</button>
                </div>
            </div>
            <br/>
            <div className='row'>
                <div className='col-md-12 table-responsive table-container'>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Transaction Date</th>
                                <th>Reg Id</th>
                                <th>First Name</th>
                                <th>Middle Name</th>
                                <th>Last Name</th>
                                <th>Bank Name</th>
                                <th>Bank Account No</th>
                                <th>Bank IFSC Code</th>
                                <th>Type</th>
                                <th>Current Wallet</th>
                                <th>Debit</th>
                                <th>Bank Charges</th>
                                <th>Settlement Amount</th>
                                <th>Balance</th>
                                <th>Wallet History</th>
                                <th>Withdrawl Status</th>
                                <th>Withdrawl Approved/Rejected Date</th>
                                <th>Payment Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                walletDataToApprove.map((data) => {
                                    return (
                                        <tr>
                                            <td>{moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                                            <td>{data?.user?.reg_id}</td>
                                            <td>{data?.user?.first_name}</td>
                                            <td>{data?.user?.middle_name}</td>
                                            <td>{data?.user?.last_name}</td>
                                            <td>{data?.user?.bank_name}</td>
                                            <td>{data?.user?.bank_account_no}</td>
                                            <td>{data?.user?.ifsc_code}</td>
                                            <td>{data?.type || null}</td>
                                            <td>{parseValue(data?.user?.wallet, 'float')}</td>
                                            <td>{parseValue(data.debit,'float')}</td>
                                            <td>{parseValue(data.bank_charges,'float')}</td>
                                            <td>{parseValue(data.settlement_amount,'float')}</td>
                                            <td>{parseValue(data.balance, 'float')}</td>
                                            <td><button type='button' className='btn btn-primary form-control' onClick={() => getWalletTransactionForUser(data?.user_id)}>See Wallet History</button></td>
                                            <td>{data?.withdrawl_status == 1 ? 'Request Sent' : data?.withdrawl_status == 2 ? 'Approved' : 'Rejected'}</td>
                                            <td>
                                                {["1", "2", "3"].includes(data?.withdrawl_status) ? data?.withdrawl_approved_date || <><button type='button' className='btn btn-success form-control' onClick={() => approveWithdrawlPayment(data?.id || 0, 2)}>Approve</button> <button type='button' className='btn btn-danger ml-2 form-control' onClick={() => approveWithdrawlPayment(data?.id || 0, 3)}>Reject</button></> : 'NA'}
                                            </td>
                                            <td>{["2"].includes(data?.withdrawl_status) ? data?.payment_date || <button type='button' className='btn btn-primary form-control' onClick={() => {setAddPaymentDate(!addPaymentDate); setWalletId(data?.id);}}>Add Payment Date</button> : 'Approve First'}</td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </Table>       
                </div>
            </div>

            <Modal isOpen={addPaymentDate} toggle={() => setAddPaymentDate(!addPaymentDate)} size="md">
                <ModalHeader toggle={() => setAddPaymentDate(!addPaymentDate)}>Add Payment Date</ModalHeader>
                <ModalBody>
                    <input type='datetime-local' id='payment-date' className='form-control' defaultValue={moment().seconds(0).format('YYYY-MM-DDTHH:mm')} max={moment().seconds(0).format('YYYY-MM-DDTHH:mm')}/><br/>
                    <button type='button' className='btn btn-success btn-sm' onClick={() => updatePaymentDate()}>Save</button>
                </ModalBody>
            </Modal>

            <Modal isOpen={showWalletHistory} toggle={() => setShowWalletHistory(!showWalletHistory)} size="lg">
                <ModalHeader toggle={() => setShowWalletHistory(!showWalletHistory)}>Wallet History</ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-md-12'>
                            <button type="button" className='btn btn-info mr-3' onClick={() => handleExportCSV(1)}>Export to CSV</button>
                            <button type="button" className='btn btn-info mr-3' onClick={() => handleExportExcel(1)}>Export to Excel</button>
                            <button type="button" className='btn btn-info mr-3' onClick={() => handleExportPDF(1)}>Export to PDF</button>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-md-12 table-responsive table-container'>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                    <th>Transaction Date</th>
                                    <th>Type</th>
                                    <th>Order Id</th>
                                    <th>Credit</th>
                                    <th>Debit</th>
                                    <th>Bank Charges</th>
                                    <th>Settlement Amount</th>
                                    <th>Balance</th>
                                    <th>Withdrawl Status</th>
                                    <th>Withdrawl Approved Date</th>
                                    <th>Payment Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        walletData.map((data) => {
                                            return (
                                                <tr>
                                                    <td>{moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                                                    <td>{data?.type || null}</td>
                                                    <td>{data?.order_item?.order?.order_id || 'NA'}</td>
                                                    <td>{common.parseValue(data.credit,'float')}</td>
                                                    <td>{common.parseValue(data.debit,'float')}</td>
                                                    <td>{common.parseValue(data.bank_charges,'float')}</td>
                                                    <td>{common.parseValue(data.settlement_amount,'float')}</td>
                                                    <td>{common.parseValue(data.balance, 'float')}</td>
                                                    <td>{data?.withdrawl_status == 1 ? 'Request Sent' : data?.withdrawl_status == 2 ? 'Approved' : 'NA'}</td>
                                                    <td>{["1", "2"].includes(data?.withdrawl_status) ? data?.withdrawl_approved_date || 'Yet to be updated' : 'NA'}</td>
                                                    <td>{["1", "2"].includes(data?.withdrawl_status) ? data?.payment_date || 'Yet to be updated' : 'NA'}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </Table>       
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default Wallet;